import { Card, CardContent } from "@/components/ui/card";
import { Car, Clock, Fuel } from "lucide-react";
import { CommuteCard } from "./commute-card";
import { formatCurrency, formatMinutes } from "@/lib/format";

interface Commute {
  _id: string;
  startedAt: number;
  endedAt?: number;
  totalMiles: number;
  pauseDuration: number;
}

interface CommuteStats {
  count: number;
  totalDurationMinutes: number;
  totalMiles: number;
  fuelCost: number | null;
}

interface CommuteListProps {
  commutes: Commute[];
  stats: CommuteStats;
}

export function CommuteList({ commutes, stats }: CommuteListProps) {
  return (
    <div className="space-y-4">
      {/* Summary Card */}
      <Card>
        <CardContent className="p-4">
          <h3 className="font-semibold flex items-center gap-2 mb-3">
            <Car className="h-4 w-4" />
            Commutes ({stats.count})
          </h3>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <p className="text-muted-foreground flex items-center gap-1">
                <Clock className="h-3 w-3" />
                Duration
              </p>
              <p className="font-medium text-lg">
                {formatMinutes(stats.totalDurationMinutes)}
              </p>
            </div>
            <div className="text-right">
              <p className="text-muted-foreground">Distance</p>
              <p className="font-medium text-lg">
                {stats.totalMiles.toFixed(1)} mi
              </p>
            </div>
            {stats.fuelCost !== null && (
              <div className="col-span-2 pt-3 border-t">
                <div className="flex items-center justify-between">
                  <span className="text-muted-foreground flex items-center gap-1">
                    <Fuel className="h-3 w-3" />
                    Est. Fuel Cost
                  </span>
                  <span className="font-medium text-destructive">
                    -{formatCurrency(stats.fuelCost)}
                  </span>
                </div>
              </div>
            )}
          </div>
        </CardContent>
      </Card>

      {/* Commute list */}
      <div className="space-y-2">
        {commutes.map((commute) => (
          <CommuteCard key={commute._id} commute={commute} />
        ))}
      </div>
    </div>
  );
}
